export const SHORT_LIVED_CACHE = 5 * 60 * 1000; // 5 minutes, data changes infrequently
export const MEDIUM_LIVED_CACHE = 30 * 60 * 1000; // 30 minutes, data rarely changes
